import { render, staticRenderFns } from "./DadosColaborador.vue?vue&type=template&id=1a1e18f8"
import script from "./DadosColaborador.vue?vue&type=script&lang=js"
export * from "./DadosColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports